<pdq-tabs-group class="upsell-tabs" variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
  @for (tab of tabs; track tab.value) {
    <pdq-tab
      [label]="tab.label"
      [value]="tab.value"
      [active]="tab.value === activeTab"
      [disabled]="isTabDisabled(tab)"
      [locked]="tab.locked"></pdq-tab>
  }
</pdq-tabs-group>

<div class="checkout-shipping-upsell">
  <div class="content">
    <form [formGroup]="formGroup">
      @switch (activeTab) {
        @case (CheckoutUpsellTab.SETTINGS) {
          <checkout-upsell-settings
            [formGroup]="formGroup"
            [defaultCurrencySymbol]="defaultCurrencySymbol"
            [showDiscountSection]="showDiscountSection"
            [showLegacyDiscountControls]="showLegacyDiscountControls"
            [showStaticDiscountControls]="showStaticDiscountControls"
            [autonomousDiscountFlagOn]="autonomousDiscountFlagOn"
            [allowedDiscountValues]="allowedDiscountValuesFormArray"
            (autonomousDiscountToggled)="onAutonomousDiscountToggled($event)"
            (addAllowedDiscountValue)="addAllowedDiscountValue()"
            (removeAllowedDiscountValue)="removeAllowedDiscountValue($event)">
          </checkout-upsell-settings>
        }
        @case (CheckoutUpsellTab.DISPLAY_CONDITIONS) {
          <checkout-upsell-display-conditions
            [formGroup]="formGroup"
            [restrictionsRules]="restrictionsRules"
            [entities]="entities"
            [shopCurrencySymbol]="shopCurrencySymbol">
          </checkout-upsell-display-conditions>
        }
        @case (CheckoutUpsellTab.GOALS) {
          <checkout-upsell-goals
            [formGroup]="formGroup"
            [freeThresholdsFormArray]="freeThresholdsFormArray"
            [thresholdType]="formGroup.get('settings.thresholdType')?.value"
            [currencyCodes]="currencyCodes"
            [defaultCountry]="defaultCountry"
            [defaultCurrency]="defaultCurrency"
            [isPreviewThresholdMode]="isPreviewThresholdMode"
            [giftUnlockExtensionsByOfferType]="giftUnlockExtensionsByOfferType"
            [giftUnlockExtensionsMap]="giftUnlockExtensionsMap"
            [goals]="goals"
            (addThreshold)="addFreeShippingThreshold()"
            (removeThreshold)="removeFreeShippingThreshold($event)"
            (isPreviewThresholdModeChange)="isPreviewThresholdMode = $event; dispatchExampleViewValues(formGroup.value)"
            (offerTypeChange)="onOfferTypeChange($event)"
            (goalsChange)="onGoalsChange($event)"
            (addGoalEvent)="addGoal()"
            (removeGoalEvent)="removeGoal($event)"
            (previewTextChange)="onPreviewTextChange($event)">
          </checkout-upsell-goals>
        }
        @case (CheckoutUpsellTab.PRODUCT_SELECTION) {
          <checkout-upsell-product-selection
            [formGroup]="formGroup"
            [shopCurrencySymbol]="shopCurrencySymbol"
            [loadedValues]="loadedExtension?.template"
            [defaultCurrencySymbol]="defaultCurrencySymbol"
            [isAutonomousDiscount]="isAutonomousDiscount">
          </checkout-upsell-product-selection>
        }
        @case (CheckoutUpsellTab.TIMER) {
          <checkout-upsell-timer
            [timerConfiguration]="currentTimerConfiguration"
            (timerConfigurationChange)="handleTimerConfigurationChange()"
            (navigateToGoalsTab)="onTabChange(CheckoutUpsellTab.GOALS)">
          </checkout-upsell-timer>
        }
      }
    </form>
  </div>
</div>
